import { render, staticRenderFns } from "./SaleInvoiceRefund.vue?vue&type=template&id=2b52163f"
import script from "./SaleInvoiceRefund.vue?vue&type=script&lang=js"
export * from "./SaleInvoiceRefund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports